// eslint-disable-next-line import/prefer-default-export
export const IS_INVITATION_ACCEPTED = 'isInvitationAccepted';
